import { Resume } from '@sr/types';
import { Box, ResumeHeading, Text } from '../common/ui';
import LeftBar from './LeftBar';

const Header = ({ resume }: { resume: Resume }) => {
  const { firstName, lastName, title, summary } = resume.about;
  return (
    <Box
      className="pdf-resume-header"
      variant="headerContainer"
      as="header"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: ['column', 'row'],
        position: 'relative',
      }}
    >
      <Box
        sx={{
          zIndex: 2,
          flexGrow: 0,
        }}
      >
        <ResumeHeading>
          {firstName} {lastName}
        </ResumeHeading>
        <LeftBar width={60}>
          <Text variant="resumeSubHeading">{title}</Text>
        </LeftBar>
      </Box>
      <Text variant="resumeSummary">{summary}</Text>
      <Text
        sx={{
          position: 'absolute',
          top: -45,
          left: -50,
          fontWeight: 'bold',
          color: 'accent1',
          fontSize: 220,
          lineHeight: 0.9,
          zIndex: 0,
          opacity: 0.1,
        }}
      >
        {firstName[0]}
        <br />
        {lastName[0]}
      </Text>
    </Box>
  );
};

export default Header;
